import {
	filterByCreditQuality,
	filterByFundingType,
	filterByLoanAmount,
	filterByMonthlyRevenue,
} from "../../src/helpers/filters";

/* constants for verticals  */
export const TAX_RELIEF_DEFAULT_PATH = "tax-relief";
export const CREDIT_REPAIR_DEFAULT_PATH = "credit-repair";
export const CREDIT_MONITORING_DEFAULT_PATH = "credit-monitoring";
export const DEBT_RELIEF_DEFAULT_PATH = "debt-relief";
export const BUSINESS_LOANS_DEFAULT_PATH = "business-loans";
export const PERSONAL_LOANS_DEFAULT_PATH = "personal-loans";
export const STUDENT_LOANS_REFINANCE_DEFAULT_PATH = "student-loan-refinance";
export const CREDIT_BUILDER_LOANS_DEFAULT_PATH = "credit-builder-loans";
export const PAYDAY_LOANS_PATH = "payday-loans";
export const IDENTITY_THEFT_PROTECTION_PATH = "identity-theft-protection";
export const AUTO_REFINANCE_PATH = "auto-refinance";
export const MORTGAGE_REFINANCE_PATH = "mortgage-refinance";
export const BUSINESS_BANKING_PATH = "business-banking";
export const BILL_NEGOTIATION_PATH = "bill-negotiation";
export const SHARED_EQUITY_AGREEMENTS_PATH = "shared-equity-agreements";
export const ALTERNATIVE_INVESTMENTS_PATH = "alternative-investments";
export const TAX_PREPARATION_SERVICES_PATH = "tax-preparation-services";
export const SPEND_MANAGEMENT_PATH = "spend-management";
export const FINANCIAL_ADVISORS_PATH = "financial-advisors";

/* URL filter parameters */
export const BAD_CREDIT_QUALITY_URL_PARAMETER = "bad-credit";
export const FAST_LOANS_CREDIT_QUALITY_URL_PARAMETER = "fast-loans";
export const QUICK_LOANS_CREDIT_QUALITY_URL_PARAMETER = "quick-loans";
export const EMERGENCY_LOANS_CREDIT_QUALITY_URL_PARAMETER = "emergency-loans";
export const FAIR_CREDIT_QUALITY_URL_PARAMETER = "fair-credit";
export const GOOD_CREDIT_QUALITY_URL_PARAMETER = "good-credit";
export const EXCELLENT_CREDIT_QUALITY_URL_PARAMETER = "excellent-credit";
export const ONE_THOUSAND_LOAN_AMOUNT_URL_PARAMETER = "1000-loan";
export const FIVE_THOUSAND_LOAN_AMOUNT_URL_PARAMETER = "5000-loan";
export const TEN_THOUSAND_LOAN_AMOUNT_URL_PARAMETER = "10000-loan";
export const TWENTY_FIVE_THOUSAND_LOAN_AMOUNT_URL_PARAMETER = "25000-loan";
export const FILTERING_COMBINATION_TEST_URL_PARAMETER =
	"filtering-combination-test";

export const WORKING_CAPITAL_LOANS_FUNDING_TYPE_URL_PARAMETER =
	"working-capital-loans";
export const LINE_OF_CREDIT_FUNDING_TYPE_URL_PARAMETER = "line-of-credit";
export const INVOICE_FACTORING_FUNDING_TYPE_URL_PARAMETER = "invoice-factoring";
export const TERM_LOAN_FUNDING_TYPE_URL_PARAMETER = "term-loans";
export const SBA_LOAN_FUNDING_TYPE_URL_PARAMETER = "sba-loans";
export const FUNDING_MARKETPLACE_FUNDING_TYPE_URL_PARAMETER =
	"funding-marketplace";

/* Constants used for filtering UI*/

// for business-loans
// the value and labels are the same for this vertical; adding a separate label for clarity though
export const WORKING_CAPITAL_LOANS_FUNDING_TYPE_FILTERING_VALUE =
	"Working Capital Loans";
export const WORKING_CAPITAL_LOANS_FUNDING_TYPE_FILTERING_LABEL =
	"Working Capital Loans";
export const LINE_OF_CREDIT_FUNDING_TYPE_FILTERING_VALUE = "Line of Credit";
export const LINE_OF_CREDIT_FUNDING_TYPE_FILTERING_LABEL = "Line of Credit";
export const INVOICE_FACTORING_FUNDING_TYPE_FILTERING_VALUE =
	"Invoice Factoring";
export const INVOICE_FACTORING_FUNDING_TYPE_FILTERING_LABEL =
	"Invoice Factoring";
export const TERM_LOAN_FUNDING_TYPE_FILTERING_VALUE = "Term Loan";
export const TERM_LOAN_FUNDING_TYPE_FILTERING_LABEL = "Term Loan";
export const SBA_LOANS_FUNDING_TYPE_FILTERING_VALUE = "SBA Loan";
export const SBA_LOANS_FUNDING_TYPE_FILTERING_LABEL = "SBA Loan";
export const FUNDING_MARKETPLACE_FUNDING_TYPE_FILTERING_VALUE =
	"Funding Marketplace";
export const FUNDING_MARKETPLACE_FUNDING_TYPE_FILTERING_LABEL =
	"Funding Marketplace";

export const ONE_THOUSAND_LOAN_AMOUNT_FILTERING_VALUE = 1000;
export const FIVE_THOUSAND_LOAN_AMOUNT_FILTERING_VALUE = 5000;
export const TEN_THOUSAND_LOAN_AMOUNT_FILTERING_VALUE = 10000;
export const TWENTY_FIVE_THOUSAND_LOAN_AMOUNT_FILTERING_VALUE = 25000;

export const EXCELLENT_CREDIT_QUALITY_FILTERING_VALUE = "Excellent";
export const EXCELLENT_CREDIT_QUALITY_FILTERING_LABEL = "Excellent (720 - 850)";
export const GOOD_CREDIT_QUALITY_FILTERING_VALUE = "Good";
export const GOOD_CREDIT_QUALITY_FILTERING_LABEL = "Good (690 - 719)";
export const FAIR_CREDIT_QUALITY_FILTERING_VALUE = "Fair";
export const FAIR_CREDIT_QUALITY_FILTERING_LABEL = "Fair (630 - 689)";
export const POOR_CREDIT_QUALITY_FILTERING_VALUE = "Poor";
export const POOR_CREDIT_QUALITY_FILTERING_LABEL = "Poor (350 - 629)";

/* Also constants for filtering UI, specifically filtering keys*/
export const CREDIT_QUALITY_FILTERING_KEY = "creditQuality";
export const LOAN_AMOUNT_FILTERING_KEY = "loanAmount";
export const FUNDING_TYPE_FILTERING_KEY = "fundingType";
export const MONTHLY_REVENUE_FILTERING_KEY = "monthlyRevenue";

export const TCR_SITE_CONFIGURATION = {
	[PERSONAL_LOANS_DEFAULT_PATH]: {
		companyListHeaderParts: [
			"provider",
			"Est.APR",
			"Loan Term",
			"Max Loan",
			"Why We Recommend",
		],
		serviceRightColumns: [
			{
				fields: ["minimumApr", "maximumApr"],
				label: "APR Range",
				formatter: ([minimumApr, maximumApr]) =>
					`${minimumApr} - ${maximumApr}%`,
			},
			{
				fields: ["minimumLoanTerm", "maximumLoanTerm"],
				label: "Loan Term",
				formatter: ([minimumLoanTerm, maximumLoanTerm]) =>
					`${minimumLoanTerm} - ${maximumLoanTerm} mo`,
				defaultValue: "24 - 84 mo",
			},
			{
				fields: "maximumLoanAmount",
				label: "max loan",
				preFormatterConversions: {
					currencyConversions: {
						isConverted: true,
					},
				},
			},
		],
		isMobileRatingUsedForMobileTargetedPaths: true,
		filteringInformation: {
			filterFunctions: {
				[CREDIT_QUALITY_FILTERING_KEY]: filterByCreditQuality,
				[LOAN_AMOUNT_FILTERING_KEY]: filterByLoanAmount,
			},
			urlPathFilteringConfiguration: {
				[BAD_CREDIT_QUALITY_URL_PARAMETER]: [
					{
						filteringKey: CREDIT_QUALITY_FILTERING_KEY,
						filterValue: POOR_CREDIT_QUALITY_FILTERING_VALUE,
					},
				],
				[FAST_LOANS_CREDIT_QUALITY_URL_PARAMETER]: [
					{
						filteringKey: CREDIT_QUALITY_FILTERING_KEY,
						filterValue: POOR_CREDIT_QUALITY_FILTERING_VALUE,
					},
				],
				[QUICK_LOANS_CREDIT_QUALITY_URL_PARAMETER]: [
					{
						filteringKey: CREDIT_QUALITY_FILTERING_KEY,
						filterValue: POOR_CREDIT_QUALITY_FILTERING_VALUE,
					},
				],
				[EMERGENCY_LOANS_CREDIT_QUALITY_URL_PARAMETER]: [
					{
						filteringKey: CREDIT_QUALITY_FILTERING_KEY,
						filterValue: POOR_CREDIT_QUALITY_FILTERING_VALUE,
					},
				],
				[FAIR_CREDIT_QUALITY_URL_PARAMETER]: [
					{
						filteringKey: CREDIT_QUALITY_FILTERING_KEY,
						filterValue: FAIR_CREDIT_QUALITY_FILTERING_VALUE,
					},
				],
				[GOOD_CREDIT_QUALITY_URL_PARAMETER]: [
					{
						filteringKey: CREDIT_QUALITY_FILTERING_KEY,
						filterValue: GOOD_CREDIT_QUALITY_FILTERING_VALUE,
					},
				],
				[EXCELLENT_CREDIT_QUALITY_URL_PARAMETER]: [
					{
						filteringKey: CREDIT_QUALITY_FILTERING_KEY,
						filterValue: EXCELLENT_CREDIT_QUALITY_FILTERING_VALUE,
					},
				],
				[ONE_THOUSAND_LOAN_AMOUNT_URL_PARAMETER]: [
					{
						filteringKey: CREDIT_QUALITY_FILTERING_KEY,
						filterValue: POOR_CREDIT_QUALITY_FILTERING_VALUE,
					},
					{
						filteringKey: LOAN_AMOUNT_FILTERING_KEY,
						filterValue: ONE_THOUSAND_LOAN_AMOUNT_FILTERING_VALUE,
					},
				],
				[FIVE_THOUSAND_LOAN_AMOUNT_URL_PARAMETER]: [
					{
						filteringKey: CREDIT_QUALITY_FILTERING_KEY,
						filterValue: GOOD_CREDIT_QUALITY_FILTERING_VALUE,
					},
					{
						filteringKey: LOAN_AMOUNT_FILTERING_KEY,
						filterValue: FIVE_THOUSAND_LOAN_AMOUNT_FILTERING_VALUE,
					},
				],
				[TEN_THOUSAND_LOAN_AMOUNT_URL_PARAMETER]: [
					{
						filteringKey: CREDIT_QUALITY_FILTERING_KEY,
						filterValue: GOOD_CREDIT_QUALITY_FILTERING_VALUE,
					},
					{
						filteringKey: LOAN_AMOUNT_FILTERING_KEY,
						filterValue: TEN_THOUSAND_LOAN_AMOUNT_FILTERING_VALUE,
					},
				],
				[TWENTY_FIVE_THOUSAND_LOAN_AMOUNT_URL_PARAMETER]: [
					{
						filteringKey: CREDIT_QUALITY_FILTERING_KEY,
						filterValue: GOOD_CREDIT_QUALITY_FILTERING_VALUE,
					},
					{
						filteringKey: LOAN_AMOUNT_FILTERING_KEY,
						filterValue: TWENTY_FIVE_THOUSAND_LOAN_AMOUNT_FILTERING_VALUE,
					},
				],
				[FILTERING_COMBINATION_TEST_URL_PARAMETER]: [
					{
						filteringKey: CREDIT_QUALITY_FILTERING_KEY,
						filterValue: POOR_CREDIT_QUALITY_FILTERING_VALUE,
					},
					{
						filteringKey: LOAN_AMOUNT_FILTERING_KEY,
						filterValue: TWENTY_FIVE_THOUSAND_LOAN_AMOUNT_FILTERING_VALUE,
					},
				],
			},
			filteringControls: [
				{
					title: "Credit Score",
					icon: "/react-images/thecreditreview/creditScoreIcon.svg",
					filteringKey: CREDIT_QUALITY_FILTERING_KEY,
					options: [
						{
							value: POOR_CREDIT_QUALITY_FILTERING_VALUE,
							label: POOR_CREDIT_QUALITY_FILTERING_LABEL,
						},
						{
							value: FAIR_CREDIT_QUALITY_FILTERING_VALUE,
							label: FAIR_CREDIT_QUALITY_FILTERING_LABEL,
						},
						{
							value: GOOD_CREDIT_QUALITY_FILTERING_VALUE,
							label: GOOD_CREDIT_QUALITY_FILTERING_LABEL,
						},
						{
							value: EXCELLENT_CREDIT_QUALITY_FILTERING_VALUE,
							label: EXCELLENT_CREDIT_QUALITY_FILTERING_LABEL,
						},
						{ value: "default", label: "All" },
					],
				},
			],
		},
	},
	[CREDIT_REPAIR_DEFAULT_PATH]: {
		preventRenderingCompanyListHeader: true,
	},
	[DEBT_RELIEF_DEFAULT_PATH]: {
		preventRenderingCompanyListHeader: true,
		serviceBlockCallout: {
			field: "minimumDebtAmount",
			preFormatterConversions: {
				isConvertedToCurrency: true,
			},
			formatter: (postConversionValue) =>
				`Minimum Debt: ${postConversionValue}`,
		},
	},
	[CREDIT_MONITORING_DEFAULT_PATH]: {
		companyListHeaderParts: [
			"provider",
			"Starting price",
			"Reports Included",
			"Credit score update frequency",
			"Why We Recommend",
		],
		serviceRightColumns: [
			{
				fields: "startingMonthlyPricing",
				label: "Starting price",
				preFormatterConversions: {
					currencyConversions: {
						isConverted: true,
					},
				},
				formatter: (minimumMonthlyRevenue) => `${minimumMonthlyRevenue}/mo`,
			},
			{ fields: "creditScoresIncluded", label: "Reports Included" },
			{
				fields: "creditScoreUpdateFrequency",
				label: "Credit score update frequency",
			},
		],
	},
	[BUSINESS_LOANS_DEFAULT_PATH]: {
		companyListHeaderParts: [
			"Provider",
			"Min. Time In Business",
			"Min. Revenue",
			"BBB Rating",
			"Why we recommend",
		],
		serviceRightColumns: [
			{ fields: "minimumTimeInBusiness", label: "Min. Time in Business" },
			{
				fields: "minimumMonthlyRevenue",
				label: "Min. Revenue",
				preFormatterConversions: {
					currencyConversions: {
						isConverted: true,
						isAbbreviated: true,
					},
				},
				formatter: (minimumMonthlyRevenue) => `${minimumMonthlyRevenue}/mo`,
			},
			{ fields: "bbbRating", label: "BBB Rating" },
		],
		filteringInformation: {
			filterFunctions: {
				[FUNDING_TYPE_FILTERING_KEY]: filterByFundingType,
				[MONTHLY_REVENUE_FILTERING_KEY]: filterByMonthlyRevenue,
			},
			urlPathFilteringConfiguration: {
				[WORKING_CAPITAL_LOANS_FUNDING_TYPE_URL_PARAMETER]: [
					{
						filteringKey: FUNDING_TYPE_FILTERING_KEY,
						filterValue: WORKING_CAPITAL_LOANS_FUNDING_TYPE_FILTERING_VALUE,
					},
				],
				[LINE_OF_CREDIT_FUNDING_TYPE_URL_PARAMETER]: [
					{
						filteringKey: FUNDING_TYPE_FILTERING_KEY,
						filterValue: LINE_OF_CREDIT_FUNDING_TYPE_FILTERING_VALUE,
					},
				],
				[INVOICE_FACTORING_FUNDING_TYPE_URL_PARAMETER]: [
					{
						filteringKey: FUNDING_TYPE_FILTERING_KEY,
						filterValue: INVOICE_FACTORING_FUNDING_TYPE_FILTERING_VALUE,
					},
				],
				[FUNDING_MARKETPLACE_FUNDING_TYPE_URL_PARAMETER]: [
					{
						filteringKey: FUNDING_TYPE_FILTERING_KEY,
						filterValue: FUNDING_MARKETPLACE_FUNDING_TYPE_FILTERING_VALUE,
					},
				],
			},
			filteringControls: [
				{
					title: "Funding Type",
					icon: "/react-images/thecreditreview/fundingType.svg",
					filteringKey: FUNDING_TYPE_FILTERING_KEY,
					options: [
						{
							value: WORKING_CAPITAL_LOANS_FUNDING_TYPE_FILTERING_VALUE,
							label: WORKING_CAPITAL_LOANS_FUNDING_TYPE_FILTERING_LABEL,
						},
						{
							value: LINE_OF_CREDIT_FUNDING_TYPE_FILTERING_VALUE,
							label: LINE_OF_CREDIT_FUNDING_TYPE_FILTERING_LABEL,
						},
						{
							value: INVOICE_FACTORING_FUNDING_TYPE_FILTERING_VALUE,
							label: INVOICE_FACTORING_FUNDING_TYPE_FILTERING_LABEL,
						},
						{
							value: TERM_LOAN_FUNDING_TYPE_FILTERING_VALUE,
							label: TERM_LOAN_FUNDING_TYPE_FILTERING_LABEL,
						},
						{
							value: SBA_LOANS_FUNDING_TYPE_FILTERING_VALUE,
							label: SBA_LOANS_FUNDING_TYPE_FILTERING_LABEL,
						},
						{
							value: FUNDING_MARKETPLACE_FUNDING_TYPE_FILTERING_VALUE,
							label: FUNDING_MARKETPLACE_FUNDING_TYPE_FILTERING_LABEL,
						},
						{ value: "default", label: "All Types" },
					],
				},
				{
					title: "Monthly Revenue",
					icon: "/react-images/thecreditreview/monthlyRevenue.svg",
					filteringKey: MONTHLY_REVENUE_FILTERING_KEY,
					options: [
						{ value: 8000, label: "$0 - $8,000" },
						{ value: 12000, label: "$8,000 - $12,000" },
						{ value: 100000, label: "Greater than $12,000" },
						{ value: "default", label: "Your Monthly Rev." },
					],
				},
			],
		},
	},
	[STUDENT_LOANS_REFINANCE_DEFAULT_PATH]: {
		showFeaturedCompany: true,
		companyListHeaderParts: [
			"provider",
			"Minimum Credit Score",
			"Starting Fixed APR",
			"BBB Rating",
			"Why We Recommend",
		],
		serviceRightColumns: [
			{ fields: "creditScoreRequired", label: "Min. Credit Score" },
			{
				fields: "startingFixedApr",
				label: "Starting Fixed APR",
				formatter: (startingFixedApr) => `${startingFixedApr}%`,
			},
			{ fields: "bbbRating", label: "BBB Rating" },
		],
	},
	[TAX_RELIEF_DEFAULT_PATH]: {
		serviceBlockCallout: {
			field: "minimumDebtAmount",
			preFormatterConversions: {
				isConvertedToCurrency: true,
			},
			formatter: (postConversionValue) =>
				`${postConversionValue}+ Tax Amount Required`,
		},
		preventRenderingCompanyListHeader: true,
	},
	[CREDIT_BUILDER_LOANS_DEFAULT_PATH]: {
		preventRenderingCompanyListHeader: true,
	},
	[PAYDAY_LOANS_PATH]: {
		companyListHeaderParts: [
			"provider",
			"BBB Rating",
			"Year Founded",
			"Why We Recommend",
		],
		serviceRightColumns: [
			{ fields: "bbbRating", label: "BBB Rating" },
			{ fields: "yearFounded", label: "Year Founded" },
		],
	},
	[IDENTITY_THEFT_PROTECTION_PATH]: {
		companyListHeaderParts: [
			"provider",
			"Starting Pricing",
			"Identity Theft Insurance",
			"Year Founded",
			"Why We Recommend",
		],
		serviceRightColumns: [
			{
				fields: "startingMonthlyPricing",
				label: "Starting Pricing",
				preFormatterConversions: {
					currencyConversions: {
						isConverted: true,
					},
				},
				formatter: (startingMonthlyPricing) => `${startingMonthlyPricing}/mo`,
			},
			{
				fields: "identityTheftInsuranceAmount",
				label: "Identity Theft Insurance",
				formatter: (insuranceAmount) => `Up to ${insuranceAmount}*`,
			},
			{ fields: "yearFounded", label: "Year Founded" },
		],
	},
	[AUTO_REFINANCE_PATH]: {
		showFeaturedCompany: true,
		preventRenderingCompanyListHeader: true,
		serviceRightColumns: [
			{
				fields: "startingApr",
				label: "Starting APR",
				icon: "/react-images/thecreditreview/startingAprIcon.svg",
				formatter: (startingApr) => `${startingApr}%`,
			},
			{
				fields: "numberOfCustomersServed",
				label: "Customers Served",
				icon: "/react-images/thecreditreview/customersServedIcon.svg",
				preFormatterConversions: { numbers: { addCommaSeparator: true } },
			},
		],
		filteringInformation: {
			filterFunctions: {
				[CREDIT_QUALITY_FILTERING_KEY]: filterByCreditQuality,
			},
			filteringControls: [
				{
					title: "Credit Score",
					icon: "/react-images/thecreditreview/creditScoreIcon.svg",
					filteringKey: CREDIT_QUALITY_FILTERING_KEY,
					options: [
						{
							value: POOR_CREDIT_QUALITY_FILTERING_VALUE,
							label: POOR_CREDIT_QUALITY_FILTERING_LABEL,
						},
						{
							value: FAIR_CREDIT_QUALITY_FILTERING_VALUE,
							label: FAIR_CREDIT_QUALITY_FILTERING_LABEL,
						},
						{
							value: GOOD_CREDIT_QUALITY_FILTERING_VALUE,
							label: GOOD_CREDIT_QUALITY_FILTERING_LABEL,
						},
						{
							value: EXCELLENT_CREDIT_QUALITY_FILTERING_VALUE,
							label: EXCELLENT_CREDIT_QUALITY_FILTERING_LABEL,
						},
						{ value: "default", label: "All" },
					],
				},
			],
		},
	},
	[MORTGAGE_REFINANCE_PATH]: {
		companyListHeaderParts: [
			"provider",
			"Minimum credit score",
			"Alternative credit considered?",
			"National or Regional?",
			"Why We Recommend",
		],
		serviceRightColumns: [
			{ fields: "minimumCreditScore", label: "Minimum credit score" },
			{
				fields: "alternativeCreditConsideration",
				label: "Alternative credit considered?",
			},
			{ fields: "nationalOrRegional", label: "National / Regional" },
		],
	},
	[BUSINESS_BANKING_PATH]: {
		showFeaturedCompany: true,
		preventRenderingCompanyListHeader: true,
		serviceRightColumns: [
			{ fields: "cashbackPercentage", label: "Cashback Rewards" },
			{ fields: "monthlyServiceFees", label: "Required service fees" },
			{
				fields: "interestRate",
				label: "Interest Rate",
				formatter: (interestRate) => {
					const interestStr = String(interestRate);
					const hasAsterisk = interestStr.endsWith("*");
					const numericPart = hasAsterisk
						? interestStr.slice(0, -1)
						: interestStr;
					const numValue = Number(numericPart.trim());

					if (isNaN(numValue)) return "N/A";

					// eslint-disable-next-line no-magic-numbers
					return `${numValue.toFixed(2)}%${hasAsterisk ? "⁎" : ""}`;
				},
			},
		],
	},
	[BILL_NEGOTIATION_PATH]: {
		companyListHeaderParts: [
			"provider",
			"Year Founded",
			"Pricing",
			"BBB Rating",
			"Why We Recommend",
		],
		serviceRightColumns: [
			{ fields: "yearFounded", label: "Year Founded" },
			{ fields: "pricing", label: "Pricing" },
			{ fields: "bbbRating", label: "BBB Rating" },
		],
	},
	[SHARED_EQUITY_AGREEMENTS_PATH]: {
		companyListHeaderParts: [
			"provider",
			"Maximum Investment",
			"Term Length",
			"Service Fee",
			"Why We Recommend",
		],
		serviceRightColumns: [
			{
				fields: "maximumInvestment",
				label: "Maximum Investment",
				formatter: (maximumInvestment) =>
					`$${maximumInvestment.toLocaleString("en-US")}`,
			},
			{ fields: "termLength", label: "Term Length" },
			{ fields: "serviceFee", label: "Service Fee" },
		],
	},
	[ALTERNATIVE_INVESTMENTS_PATH]: {
		companyListHeaderParts: [
			"Platform",
			"Year Founded",
			"Investment Type",
			"Minimum Investment",
			"Why We Recommend",
		],
		serviceRightColumns: [
			{ fields: "yearFounded", label: "Year Founded" },
			{ fields: "investmentType", label: "Investment Type" },
			{ fields: "minimumInvestment", label: "Minimum Investment" },
		],
	},
	[TAX_PREPARATION_SERVICES_PATH]: {
		companyListHeaderParts: [
			"Tax Preparation Service",
			"Starting Pricing",
			"In-person Option?",
			"Year Founded",
			"Why We Recommend",
		],
		serviceRightColumns: [
			{ fields: "pricing", label: "Pricing" },
			{ fields: "inPersonOption", label: "In-person Option?" },
			{ fields: "yearFounded", label: "Year Founded" },
		],
	},
	[SPEND_MANAGEMENT_PATH]: {
		showFeaturedCompany: true,
		companyListHeaderParts: [
			"provider",
			"Rewards",
			"Support",
			"Why We Recommend",
		],
		serviceRightColumns: [
			{ fields: "rewards", label: "Rewards" },
			{ fields: "support", label: "Support" },
		],
	},
	[FINANCIAL_ADVISORS_PATH]: {
		preventRenderingCompanyListHeader: true,
	},
};
